// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/1344
import type { PAPEventGeneric } from "../base/event";
import type { DashSurface } from "../enums/dash_surface";
import type { Environment } from "../enums/environment";
import type { OperatingSystem } from "../enums/operating_system";
import type { StackAccessLevel } from "../enums/stack_access_level";
import type { StackPermissions } from "../enums/stack_permissions";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { FeatureLine } from "../enums/feature_line";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { StackCreationType } from "../enums/stack_creation_type";

// Event_name: 'copy.dash_stack_shared_link'
// Description: Fires when user clicks the Copy link button on a stack or within the Share modal to copy the link to a stack
// Owner: content-ingest
export type Copy_DashStackSharedLink = PAPEventGeneric<
  'stacks',
  'copy',
  'dash_stack_shared_link',
  {
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // Whether the app dispatching the event is Prod, Test, or Dev (run locally by the developer)
    environment?: Environment;
    // The operating system platform the user is running on.
    operatingSystem?: OperatingSystem;
    // the start time of the event in ms
    startTimeMs?: number;
    // generic property representing build version of whatever is logging this event.
    buildVersion?: string;
    // The stack id that represents the stack
    stackId?: string;
    // User_id associated with the creator of the content being acted upon
    creatorId?: string;
    // Answers if the event actor on the stack is the same as the creator of the stack
    isOwner?: boolean;
    // marks if the content is shared content
    isShared?: boolean;
    // True if public sharing is allowed, false otherwise
    isPublicSharingAllowed?: boolean;
    // Hashed URLs accessed by Dash. These are pre-hashed.
    dashUrlHash?: string;
    // The stack id that represents the stack (without extra hashing on the client side)
    unhashedStackId?: string;
    // The access level settings for a stack
    stackAccessLevel?: StackAccessLevel;
    // Whether the user is interacting with their welcome stack
    isWelcomeStack?: boolean;
    // The permissions of a user on a stack
    stackPermissions?: StackPermissions;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // Indicates how the stack was created. See APIv2's StackCreationType.
    stackCreationType?: StackCreationType;
  }
>;

export function PAP_Copy_DashStackSharedLink(properties?: Copy_DashStackSharedLink['properties']): Copy_DashStackSharedLink {
  return <Copy_DashStackSharedLink>{
    class: 'stacks',
    action: 'copy',
    object: 'dash_stack_shared_link',
    properties,
  };
}
